import { TenantCustomizationService } from './services/tenant-customization.service';
import {
  Component,
  TemplateRef,
  ChangeDetectorRef,
  OnInit,
  AfterViewInit,
} from '@angular/core';
import {
  INavbarOptions,
  LayoutService,
  IAsideLeftOptions,
  InfiniteScrollOptions,
  IButtonOptions,
  Status,
  IOnboarding,
  OnboardingService,
} from 'codex-lib';
import { RoutePages } from './enum/route-pages';
import { RouteService } from './services/route.service';
import { Router } from '@angular/router';
import { NewEnvelopeService } from './envelope/new-envelope/new-envelope.service';
import { MainLayoutService } from './services/main-layout.service';
import { AuthService } from '../app/services/auth.service';
import { CodexNotificationService } from './services/codex-notification.service';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { CookieWrapperService } from './services/cookie-wrapper.service';
import { UserTypes } from './enum/user-types';
import { SurvicateService } from './services/survicate.service';
import { BrowserUtil } from './util/browser-util';
import { DashboardService } from './modules/dashboard/services/dashboard.service';
import { ApiUrlUtil } from './util/api-url-util';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NavigationEnd } from '@angular/router';
import { filter, switchMap, take } from 'rxjs/operators';
import { SentEnvelopeFilter } from './envelope/model/sent-envelope-filter';
import { SentEnvelopeStatusCounter } from './envelope/model/sent-envelope-status-counter';
import { forkJoin, from, Observable } from 'rxjs';
import { SharedService } from './services/shared-service.service';
import { TenantSettingsService } from './services/tenant-settings.service';
import { MenuEnum } from './enum/menu.enum';
import { FeatureEnum } from './enum/feature.enum';
import { EnvelopeOnBoardingService } from './envelope/services/envelope-on-boarding.service';
import { WhatasappSettingsService } from './modules/settings/services/whatsapp-settings.service';
import { SvgIllustrationService } from './services/svg-illustration.service';

import { TrackerData } from 'src/app/modules/google-analytics/model/tracker-data.model';
import { AnalyticEventClient } from 'src/app/enum/analytic-event-client.enum';
import { AnalyticsService } from 'src/app/modules/google-analytics/service/analytics.service';
import { ContactsRoutePages } from './modules/contacts/enum/contacts-route-pages';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, AfterViewInit {
  title = 'satelitti-signer-fe';
  profileType: UserTypes = null;
  firstOpen = false;
  isSignFree = false;
  statusCounter: SentEnvelopeStatusCounter;
  isMobile: boolean = BrowserUtil.isMobile();
  isWhatsAppButton = false;
  canShowAddEnvelope = false;
  showOnboardingMobile: boolean;

  previousUrl: string = null;
  currentUrl: string = null;

  defaultTemplate = false;
  // #region NAVBAR
  navbarOptions: INavbarOptions;
  user: string;

  // #endregion

  // #region SIDEBAR LEFT
  showLeft = false;
  hideLeft = false;
  hideTop = false;
  leftOptions: IAsideLeftOptions;

  // #region TOOLBAR
  toolbarRef: TemplateRef<any>;
  defaultrow;
  // #endregion

  // #region SCROLL
  infiniteScrollOptions: InfiniteScrollOptions = new InfiniteScrollOptions();
  // #endregion

  // #region VIEWER
  showViewer = false;
  // #endregion

  buttonOptions: IButtonOptions[];
  suiteUserCustomization: void;
  filter: SentEnvelopeFilter;

  showEhatsappChangeOnboarding: boolean = false;
  whatsappChangeOnboarding: IOnboarding[] = [
    {
      title: 'onboardings.systemWhatsAppNumberChange.title',
      subtitle: 'onboardings.systemWhatsAppNumberChange.subtitle',
      btnPrimary: 'onboardings.systemWhatsAppNumberChange.btnPrimary',
      actionColumn: false,
      link: {
        href: "",
        showInSubtitle: true,
        text: ""
      },
      svg: ""
    }
  ];

  constructor(
    private survicateService: SurvicateService,
    private layoutService: LayoutService,
    private router: Router,
    private routeService: RouteService,
    private changeDetectorRef: ChangeDetectorRef,
    public newEnvelopeService: NewEnvelopeService,
    private mainLayoutService: MainLayoutService,
    private authService: AuthService,
    private codexNotificationService: CodexNotificationService,
    private translateService: TranslateService,
    private cookieWrapperService: CookieWrapperService,
    private dashboardService: DashboardService,
    private onboardingService: OnboardingService,
    private modalService: NgbModal,
    private tenantCustomizationService: TenantCustomizationService,
    private sharedService: SharedService,
    private tenantSettingsService: TenantSettingsService,
    private signerOnboardingService: EnvelopeOnBoardingService,
    private whatasappSettingsService: WhatasappSettingsService,
    private svgIllustrationService: SvgIllustrationService,
    private googleAnalitycsService: AnalyticsService
  ) {
    this.firstOpen = true;
    this.isSignFree = this.survicateService.isSignFree();
    this.canShowFloatingButton(null);

    // #region VIEWER
    this.layoutService.toggleViewerProp.subscribe((x) => (this.showViewer = x));
    // #endregion

    // #region LOGO
    this.layoutService.logoProp.value.img = 'assets/img/Logo_Satelitti.png';
    // #endregion

    // #region SIDEBAR LEFT
    this.layoutService.toggleLeftAsideProp.subscribe(
      (x) => (this.showLeft = x)
    );

    // this.filter = new SentEnvelopeFilter();
    // this.filter.status = SentEnvelopeStatus.pending;
    // this.envelopeService
    //   .getSentEnvelopeStatusCounter(this.filter)
    //   .subscribe(this.fillStatusCounterData);

    this.routeService.navigationEnd.subscribe((navigationEnd: any) => {
      if (!navigationEnd) {
        return;
      }
      if (navigationEnd.activeRoute === undefined) {
        ApiUrlUtil.goToSuiteLogin();
        return;
      }
      this.isWhatsAppButton = false;
      this.canShowAddEnvelope = false;
      if (navigationEnd.activeRoute === RoutePages.Root && this.isSignFree) {
        this.router.navigate([RoutePages.Dashboard]);
      }
      if (navigationEnd.activeRoute === RoutePages.Root && !this.isSignFree) {
        //this.router.navigate([RoutePages.PaidDashboard]);
        this.router.navigate([RoutePages.SentEnvelope]);
      }
      if (navigationEnd.activeRoute === RoutePages.SentEnvelope) {
        this.canShowFloatingButton(navigationEnd.activeRoute);
      } else if (navigationEnd.activeRoute === RoutePages.InboxEnvelope) {
        this.canShowFloatingButton(navigationEnd.activeRoute);
        this.layoutService.headerProp.next({ title: 'inbox.title' });
      } else if (navigationEnd.activeRoute === RoutePages.Settings) {
        this.canShowFloatingButton(navigationEnd.activeRoute);
        this.layoutService.headerProp.next({ title: 'settings.title' });
      } else if (navigationEnd.activeRoute === RoutePages.Reports) {
        this.canShowFloatingButton(navigationEnd.activeRoute);
        this.layoutService.headerProp.next({ title: 'reports.title' });
      } else if (navigationEnd.activeRoute === RoutePages.Contacts) {
        this.canShowFloatingButton(navigationEnd.activeRoute);
        if (`/${RoutePages.Contacts}/${ContactsRoutePages.ContactBook}` === navigationEnd.fullUrl)
          this.layoutService.headerProp.next({ title: 'contacts.tabs.contactBook.title' });
        else
          this.layoutService.headerProp.next({ title: 'contacts.tabs.signatoryTypeRoles.title' });
      } else if (navigationEnd.activeRoute === RoutePages.FeedbackPortal) {
        this.canShowFloatingButton(navigationEnd.activeRoute);
        this.layoutService.headerProp.next({ title: 'feedbackPortal.title' });
      } else if (navigationEnd.activeRoute === RoutePages.Dashboard) {
        this.canShowFloatingButton(navigationEnd.activeRoute);
        this.layoutService.headerProp.next({ title: 'dashboard.title' });
      }

      if (
        navigationEnd.activeRoute === RoutePages.VerificationPortal ||
        navigationEnd.activeRoute === RoutePages.VerificationPortalDocument ||
        navigationEnd.activeRoute === RoutePages.Signature
      ) {
        this.hideLeft = true;
        this.hideTop = true;
      } else {
        this.hideLeft = false;
        this.hideTop = false;
        if (this.firstOpen) {
          this.codexNotificationService.getNotificationCount();
          this.firstOpen = false;
        }

        if (!this.isSignFree) {
          forkJoin({
            isActive: this.whatasappSettingsService.getSendMessageWhatsapp(),
            isEnabled: this.whatasappSettingsService.getSendingByWhatsapp()
          }).pipe(
            take(1),
            filter(({ isActive, isEnabled }) => isActive && isEnabled),
            switchMap(() => this.signerOnboardingService.verifyViewed(FeatureEnum.systemWhatsAppNumberChange)),
            filter((viewed) => !viewed),
            switchMap(() => from(this.svgIllustrationService.getSvgIllustrationRaw("assets/illustrations/whatsapp-change-onboarding.svg")))
          )
            .subscribe({
              next: (svg) => {
                this.whatsappChangeOnboarding[0].svg = svg;
                this.showEhatsappChangeOnboarding = true;
              }
            });
        }
      }

      this.leftOptions = this.getAsideLeft(this.routeService.getCurrentRoute());
    });
    // #endregion

    //#region SCROLL
    this.layoutService.configureInfiniteScroll$.subscribe(
      (options: InfiniteScrollOptions) => {
        this.infiniteScrollOptions = options;
      }
    );

    //#endregion
    this.mainLayoutService.defaultTemplate.subscribe(
      (x) => (this.defaultTemplate = x)
    );
    this.mainLayoutService.defaultTemplate.next(true);

    if (
      !this.authService.signUserModel &&
      this.authService.signUserModel !== undefined
    ) {
      return;
    }

    this.authService.authModel.subscribe((authModel) => {
      if (authModel) {
        this.user = authModel.signUser.name
          .replace(/\s\s+/g, ' ')
          .replace(/[^a-zA-Z0-9 ]/g, '')
          .replace(/\s{2,}/g, ' ');

        this.profileType = this.authService.getProfile();
        this.navbarOptions = this.getNavbarOptions(this.user);

        if (authModel.signUser.isSignFree) {
          this.setPillSignFree();
        }

        if (this.profileType === UserTypes.User) {
          this.tenantSettingsService.getTenantSettings().subscribe((settings) => {
            if (settings && settings.mainMenuObserver === MenuEnum.Sent) {
              this.router.navigate([RoutePages.SentEnvelope]);
            } else {
              this.router.navigate([RoutePages.InboxEnvelope]);
            }
          });
        }
      }
    });

    this.translateService.onLangChange.subscribe((e: LangChangeEvent) => {
      this.cookieWrapperService.setSuiteLanguage(e.lang);
      if (
        this.dashboardService.expiration !== undefined &&
        this.navbarOptions &&
        this.navbarOptions.pill
      ) {
        this.onTranslatePillText().subscribe((translate) => {
          this.navbarOptions.pill.subtitle = translate;
          this.navbarOptions.pill.type = this.onTypePill();
        });
      } else if (this.isSignFree) {
        this.setPillSignFree();
      }
    });
  }

  fillStatusCounterData = (data: SentEnvelopeStatusCounter) => {
    this.statusCounter = Object.assign({}, data);
    if (
      this.totalEnvelopeCount(this.statusCounter) === 0 &&
      this.newEnvelopeService.isFirstEnvelope
    ) {
      this.newEnvelopeService.needCreateFirstEnvelope = true;
    } else {
      this.newEnvelopeService.needCreateFirstEnvelope = false;
    }
  };

  totalEnvelopeCount(x) {
    let count = 0;
    count += x.completed;
    count += x.deleted;
    count += x.expired;
    count += x.onApproval;
    count += x.pending;
    count += x.reproved;
    count += x.toFill;
    return count;
  }
  // #endregion

  toggleLeft() {
    this.layoutService.toggleLeftAside();
  }

  sideItemClick(event: any): void {
    const route = (typeof event === 'string' ? event : event?.link) as
      | RoutePages
      | string;
    const menuName = this.getLeftMenuName(route);

    if (!menuName) {
      return;
    }

    this.googleAnalitycsService.sendEvent(
          new TrackerData(
            AnalyticEventClient.TK_PT_SIGNER_GENERAL,
            'Signer_Geral_Menu',
            menuName
          )
        );
  }

  viewerGoBack(): void { }

  canShowFloatingButton(pageRoute: any) {
    //apresenta o botão whatsapp no signfree
    if (!this.isMobile) {
      this.isWhatsAppButton = this.isSignFree;
      this.canShowAddEnvelope = false;
    }
    //apresenta o botão criar envelope no mobile.
    if (
      this.isMobile &&
      pageRoute !== null &&
      (pageRoute === RoutePages.SentEnvelope ||
        pageRoute === RoutePages.InboxEnvelope ||
        pageRoute === RoutePages.Reports)
    )
      this.canShowAddEnvelope = this.isMobile && !this.isSignFree;
  }

  ngOnInit(): void {
    this.googleAnalitycsService.sendEvent(
      new TrackerData(
        AnalyticEventClient.TK_PT_SIGNER_ACCESS,
        'Signer_acesso'
      )
    );
    this.tenantCustomizationService.tenantTheme.subscribe((tenantTheme) => {
      const body = document.getElementById('theme');
      body.className = '';
      body.classList.add(tenantTheme);
    });

    this.tenantCustomizationService.tenantLogo.subscribe((imgLogo) => {
      this.layoutService.logoProp.next({ img: imgLogo });
      const logoPath = document.getElementById('logoPath') as HTMLInputElement;
      if (logoPath) {
        logoPath.src = imgLogo;
      }
    });

    this.tenantCustomizationService.tenantIcon.subscribe((favicon) => {
      const faviconPath: HTMLLinkElement =
        document.querySelector('#faviconPath');
      faviconPath.href = favicon;
    });

    this.sharedService.currentValue.subscribe(value => {
      this.codexNotificationService.getNotificationCount(value);
    })

    if (!this.authService.signUserModel) {
      this.hideLeft = true;
      this.hideTop = true;
    }
    // #region NAVBAR
    this.navbarOptions = this.getNavbarOptions(this.user);
    // #endregion

    // #region SIDEBAR LEFT
    this.leftOptions = this.getAsideLeft(this.routeService.getCurrentRoute());
    // #endregion

    this.layoutService.toggleLoading(false);

    this.onboardingService.registerOnboarding('mobileDesktopView');
    this.onboardingService.registerOnboarding('whatsappChangeOnboarding');

    this.getPreviousUrl();
  }

  ngAfterViewInit(): void {
    // TOOLBAR
    this.layoutService.toolbarTemplateRef.subscribe((x) => {
      this.toolbarRef = x;
      this.changeDetectorRef.detectChanges();
    });
  }

  getNavbarOptions(name: string, viewer: boolean = false): INavbarOptions {
    return {
      textButton: 'codex.navbarUser.buttonViewer',
      iconButton: {
        iconName: 'arrow-left',
        prefix: 'fal',
      },
      screenTitle: 'codex.menu',
      hasSearch: false,
      isViewer: viewer,
      dropdownNavbarOptions: {
        username: name,
        hasLanguageChange: true,
        extraItens: [
          {
            text: 'codex.navbarUser.signOut',
            event: () => {
              this.routeService.logout();
            },
          },
        ],
        languages: null,
        languagesMenuText: 'codex.navbarUser.Language',
      },
    };
  }

  getAsideLeft(activeRoute: RoutePages): IAsideLeftOptions {
    return {
      product: 'Satelitti',
      icon: {
        prefix: 'fas',
        iconName: 'bars',
      },
      ca: this.canCreateNewEnvelop(activeRoute, this.profileType),
      items: this.iconsPerProfile(activeRoute),
    };
  }

  getPreviousUrl() {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.url;
      });
  }

  handleWhatsAppOnboardingView() {
    this.showEhatsappChangeOnboarding = false;
    this.markAsViewed(FeatureEnum.systemWhatsAppNumberChange);
  }

  markAsViewed(feature: FeatureEnum) {
    this.layoutService.toggleLoading(true);

    this.signerOnboardingService.maskAsViewed(feature).subscribe(
      (x) => {
        this.layoutService.toggleLoading(false);
      },
      (error: any) => {
        this.layoutService.toggleLoading(false);
      }
    );
  }

  private iconsPerProfile(activeRoute: RoutePages): IButtonOptions[] {
    const profile = this.profileType;

    if (profile === UserTypes.Admin) {
      return this.adminProfile(activeRoute);
    } else if (profile === UserTypes.PowerUser) {
      return this.publisherProfile(activeRoute);
    } else {
      return this.observerProfile(activeRoute);
    }
  }

  private adminProfile(activeRoute: RoutePages): IButtonOptions[] {
    this.buttonOptions = [
      {
        icon: {
          prefix: 'fal',
          iconName: 'paper-plane',
        },
        text: 'menu.sent',
        link: RoutePages.SentEnvelope,
        isItem: true,
        isMinimize: false,
        isActive:
          activeRoute === RoutePages.SentEnvelope ||
          activeRoute === RoutePages.Root,
      },
      {
        icon: {
          prefix: 'far',
          iconName: 'mailbox',
        },
        text: 'menu.inbox',
        link: RoutePages.InboxEnvelope,
        isItem: true,
        isMinimize: false,
        isActive: activeRoute === RoutePages.InboxEnvelope,
      },
      {
        icon: {
          prefix: 'far',
          iconName: 'chart-bar',
        },
        text: 'menu.reports',
        link: RoutePages.Reports,
        isItem: true,
        isMinimize: false,
        isActive: activeRoute === RoutePages.Reports,
      },
      {
        icon: {
          prefix: 'far',
          iconName: 'address-book',
        },
        text: 'menu.contacts',
        link: RoutePages.Contacts,
        isItem: true,
        isMinimize: false,
        isActive: activeRoute === RoutePages.Contacts,
      },
      {
        icon: {
          prefix: 'far',
          iconName: 'tools',
        },
        text: 'menu.settings',
        link: RoutePages.Settings,
        isItem: true,
        isMinimize: false,
        isActive: activeRoute === RoutePages.Settings,
      },
      this.menuFeedbackPortal(activeRoute),
    ];
    if (this.isSignFree) {
      this.buttonOptions.splice(0, 0, this.menuDashboard(activeRoute));
    } else {
      this.buttonOptions.splice(0, 0, this.menuSuite(activeRoute));
      //this.buttonOptions.splice(1, 0, this.menuPaidDashboard(activeRoute));
    }
    return this.buttonOptions;
  }

  private publisherProfile(activeRoute: RoutePages): IButtonOptions[] {
    this.buttonOptions = [
      {
        icon: {
          prefix: 'fal',
          iconName: 'paper-plane',
        },
        text: 'menu.sent',
        link: RoutePages.SentEnvelope,
        isItem: true,
        isMinimize: false,
        isActive:
          activeRoute === RoutePages.SentEnvelope ||
          activeRoute === RoutePages.Root,
      },
      {
        icon: {
          prefix: 'far',
          iconName: 'mailbox',
        },
        text: 'menu.inbox',
        link: RoutePages.InboxEnvelope,
        isItem: true,
        isMinimize: false,
        isActive: activeRoute === RoutePages.InboxEnvelope,
      },
      {
        icon: {
          prefix: 'far',
          iconName: 'address-book',
        },
        text: 'menu.contacts',
        link: RoutePages.Contacts,
        isItem: true,
        isMinimize: false,
        isActive: activeRoute === RoutePages.Contacts,
      },
      this.menuFeedbackPortal(activeRoute),
    ];
    if (this.isSignFree) {
      this.buttonOptions.splice(0, 0, this.menuDashboard(activeRoute));
      this.buttonOptions.splice(3, 0, this.menuReport(activeRoute));
      if (
        this.newEnvelopeService.needCreateFirstEnvelope &&
        this.newEnvelopeService.isFirstEnvelope
      ) {
        this.buttonOptions.splice(1, 3);
      }
    } else {
      this.buttonOptions.splice(0, 0, this.menuSuite(activeRoute));
    }
    return this.buttonOptions;
  }

  private observerProfile(activeRoute: RoutePages): IButtonOptions[] {
    this.buttonOptions = [
      {
        icon: {
          prefix: 'fal',
          iconName: 'paper-plane',
        },
        text: 'menu.sent',
        link: RoutePages.SentEnvelope,
        isItem: true,
        isMinimize: false,
        isActive:
          activeRoute === RoutePages.SentEnvelope ||
          activeRoute === RoutePages.Root,
      },
      {
        icon: {
          prefix: 'far',
          iconName: 'mailbox',
        },
        text: 'menu.inbox',
        link: RoutePages.InboxEnvelope,
        isItem: true,
        isMinimize: false,
        isActive: activeRoute === RoutePages.InboxEnvelope,
      },
      this.menuFeedbackPortal(activeRoute),
    ];
    if (this.isSignFree) {
      this.buttonOptions.splice(0, 0, this.menuDashboard(activeRoute));
      this.buttonOptions.splice(3, 0, this.menuReport(activeRoute));
    } else {
      this.buttonOptions.splice(0, 0, this.menuSuite(activeRoute));
    }
    return this.buttonOptions;
  }

  private canCreateNewEnvelop(
    activeRoute: RoutePages,
    profileType: number
  ): IButtonOptions | null {
    const addButton: IButtonOptions = {
      icon: {
        prefix: 'fal',
        iconName: 'plus',
      },
      isItem: true,
      isMinimize: false,
      isActive: activeRoute === RoutePages.MainEnvelope,
      link: RoutePages.MainEnvelope,
      text: 'menu.ca',
      stopPropagation: true,
    };

    if (profileType !== undefined && profileType !== UserTypes.User) {
      return addButton;
    }
    return null;
  }

  private menuFeedbackPortal(activeRoute: RoutePages): IButtonOptions {
    return {
      icon: {
        prefix: 'far',
        iconName: 'compass',
      },
      text: 'menu.feedbackPortal',
      link: RoutePages.FeedbackPortal,
      isItem: true,
      isMinimize: false,
      isActive: activeRoute === RoutePages.FeedbackPortal,
    };
  }

  private menuDashboard(activeRoute: RoutePages): IButtonOptions {
    const addButton: IButtonOptions = {
      icon: {
        prefix: 'fas',
        iconName: 'chart-line',
      },
      isItem: true,
      isMinimize: false,
      isActive: activeRoute === RoutePages.Dashboard,
      link: RoutePages.Dashboard,
      text: 'menu.dashboard',
    };
    return addButton;
  }

  private menuPaidDashboard(activeRoute: RoutePages): IButtonOptions {
    const addButton: IButtonOptions = {
      icon: {
        prefix: 'fas',
        iconName: 'chart-line',
      },
      isItem: true,
      isMinimize: false,
      isActive: activeRoute === RoutePages.PaidDashboard,
      link: RoutePages.PaidDashboard,
      text: 'menu.paid-dashboard',
    };
    return addButton;
  }

  private menuSuite(activeRoute: RoutePages): IButtonOptions {
    const addButton: IButtonOptions = {
      icon: {
        prefix: 'fas',
        iconName: 'arrow-left',
      },
      text: 'menu.suite',
      isActive: activeRoute === RoutePages.Suite,
      link: RoutePages.Suite,
      isItem: true,
      isMinimize: false,
    };
    return addButton;
  }

  private menuReport(activeRoute: RoutePages): IButtonOptions {
    const addButton: IButtonOptions = {
      icon: {
        prefix: 'far',
        iconName: 'chart-bar',
      },
      text: 'menu.reports',
      link: RoutePages.Reports,
      isItem: true,
      isMinimize: false,
      isActive: activeRoute === RoutePages.Reports,
    };
    return addButton;
  }

  private setPillSignFree() {
    this.dashboardService.getExpiration().subscribe((data) => {
      this.dashboardService.expiration = data;
      this.onTranslatePillText().subscribe((translate) => {
        this.navbarOptions.pill = {
          icon: {
            iconName: 'clock',
            prefix: 'fal',
          },
          description: 'codex.navbarUser.pill.description',
          subtitle: translate,
          type: this.onTypePill(),
        };
      });
    });
  }

  private onTranslatePillText(): Observable<string> {
    if (this.onTypePill() === Status.SUCCESS) {
      return this.translateService.get('codex.navbarUser.pill.term', {
        expiration: this.dashboardService.expiration,
      });
    }

    if (
      this.onTypePill() === Status.WARNING &&
      this.dashboardService.expiration > 1
    ) {
      return this.translateService.get('codex.navbarUser.pill.term', {
        expiration: this.dashboardService.expiration,
      });
    }

    if (
      this.onTypePill() === Status.WARNING &&
      this.dashboardService.expiration === 1
    ) {
      return this.translateService.get('codex.navbarUser.pill.termOneDay', {
        expiration: this.dashboardService.expiration,
      });
    }

    if (this.onTypePill() === Status.DANGER) {
      return this.translateService.get('codex.navbarUser.pill.termExpired');
    }

    return this.translateService.get('codex.navbarUser.pill.term', {
      expiration: this.dashboardService.expiration,
    });
  }

  private onTypePill() {
    if (this.dashboardService.expiration > 7) {
      return Status.SUCCESS;
    } else if (
      this.dashboardService.expiration > 0 &&
      this.dashboardService.expiration <= 7
    ) {
      return Status.WARNING;
    } else if (
      this.dashboardService.expiration === 0 ||
      this.dashboardService.expiration < 0
    ) {
      return Status.DANGER;
    } else {
      return Status.PRIMARY;
    }
  }

  private getLeftMenuName(route: RoutePages | string): string | null {
    const routeToMenuName: { [key: string]: string } = {
      [RoutePages.Suite]: 'Suite',
      [RoutePages.SentEnvelope]: 'Enviados',
      [RoutePages.InboxEnvelope]: 'Recebidos',
      [RoutePages.Reports]: 'Relatórios',
      [RoutePages.Contacts]: 'Agenda de Contatos',
      [RoutePages.Settings]: 'Configurações',
      [RoutePages.FeedbackPortal]: 'Portal de Melhorias',
    };

    return routeToMenuName[route] || null;
  }
}
